import { MEMBERSHIP_EXTENSION_MODULE } from "@/api_framework/api_config";
import {
  IMembershipExtensionUpdateProps,
  IMembershipExtensionUpdateResponse,
} from "@/api_framework/api_modals/MembershipExtension";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
type MembershipExtensionUpdateAPIResponse = { status: boolean; message: string };

export const useUpdateMembershipExtensionAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IMembershipExtensionUpdateProps, extension_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: MembershipExtensionUpdateAPIResponse = await axios
          .patch(
            `${MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_UPDATE?.baseURL}${extension_id}`,
            filterParams,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IMembershipExtensionUpdateResponse>) => {
            if (res.data.status) {
              toast.success("Membership extension has been updated.");
              return { status: true, message: "" };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        return { status: false, message: null };
      }
    },
    [dispatch, configuration],
  );
  return { execute };
};
